import addPremiessIcon from "./add-premises-icon.svg";
import lawIcon from "./law-icon.svg";
import fireSystemsIcon from "./fire-systems-icon.svg";
import constructionIcon from "./construction-icon.svg";
import maintenanceIcon from "./maintenance-icon.svg";
import emergencyPreparednessIcon from "./emergency-preparedness-icon.svg";
import hazardousIcon from "./hazardous-icon.svg";
import equipmentMaintenanceIcon from "./equipment-maintenance-icon.svg";
import safetyFacilityIcon from "./safety-facility-icon.svg";
import securityIcon from "./security-icon.svg";
import alert from "./alert.png";

import viewIcon from "./policies-manuals/view-icon.svg";

import editIcon from "./policies-manuals/edit-icon.svg";
import folderIcon from "./policies-manuals/folder-icon.svg";
import addfilesIcon from "./policies-manuals/addfiles-icon.svg";

import downloadIcon from "./policies-manuals/download-icon.svg";
import searchIcon from "./policies-manuals/search-icon.jpg";
import locationIcon from "./policies-manuals/location-orange-icon.svg";
import createFolderIcon from "./policies-manuals/create-folder-icon.svg";

// premises
import apDetectionIcon from "./fire-assessment/ap-detection-icon.svg";
import apFireAlarm from "./fire-assessment/ap-fire-alarm-icon.svg";
import apFirsRisk from "./fire-assessment/ap-fire-risk-assessment-icon.svg";
import apTraining from "./fire-assessment/ap-training-icon.svg";
import deyRisers from "./fire-assessment/ap-dry-risers-icon.svg";
import emergencyLight from "./fire-assessment/ap-emergency-lighting-icon.svg";
import evacAlert from "./fire-assessment/ap-evac-alert-system-icon.svg";
import evac from "./fire-assessment/ap-evcs-icon.svg";
import fireExtinguisher from "./fire-assessment/ap-fire-extinguisher-blankets-icon.svg";
import firefighting from "./fire-assessment/ap-fire-fighting-lifts-icon.svg";
import fireRiskAssess from "./fire-assessment/ap-fire-risk-assessment-icon.svg";
import fireShutter from "./fire-assessment/ap-fire-shutters-curtains-icon.svg";
import buildingEvacuation from "./fire-assessment/ap-full-building-evacuation-icon.svg";
import gasSuppression from "./fire-assessment/ap-gas-suppression-system-icon.svg";
import reeksHydrants from "./fire-assessment/ap-hose-reels-hydrants-icon.svg";
import kitchenSuppression from "./fire-assessment/ap-kitchen-suppression-system-icon.svg";
import sprinklerSystem from "./fire-assessment/ap-sprinkler-system-icon.svg";
import smokeControl from "./fire-assessment/ap-smoke-control-system-icon.svg";
import mistSystem from "./fire-assessment/ap-water-mist-system-icon.svg";
import CheckMark from "./checkmark-icon.svg";
import Logo from "./Logo.jpeg";
import filter from "./filters-bt-icon.svg";
import settingsImg from "./settings-bt-icon.svg";
import createUserImg from "./create-user-icon.svg";
import createRoleImg from "./create-role-icon.svg";
import selectAssetsImg from "./select-assets-img.jpeg";
import appLogo from "./karadacore-logo1.svg";
import reportedIcon from "./reported-icon.svg";
import feedbackIcon from "./feedback-icon.svg";
import auditsIcon from "./audits-icon.svg";
import complianceIcon from "./compliance-icon.svg";
import premisesIcon from "./premises-icon.svg";
import assetsIcon from "./assets-icon.svg";
import alertsIcon from "./alerts-icon.svg";
import tasksIcon from "./tasks-icon.svg";
import riskAssessmentIcon from "./risk-assessment-icon.jpg";

const images = {
  folderIcon,
  downloadIcon,
  searchIcon,
  addfilesIcon,
  locationIcon,
  filter,
  createFolderIcon,
  CheckMark,
  addPremiessIcon,
  lawIcon,
  fireSystemsIcon,
  Logo,
  alert,
  constructionIcon,
  maintenanceIcon,
  emergencyPreparednessIcon,
  hazardousIcon,
  equipmentMaintenanceIcon,
  safetyFacilityIcon,
  securityIcon,
  viewIcon,
  editIcon,
  apDetectionIcon,
  apFireAlarm,
  apFirsRisk,
  apTraining,
  deyRisers,
  emergencyLight,
  evacAlert,
  evac,
  fireExtinguisher,
  firefighting,
  fireRiskAssess,
  fireShutter,
  buildingEvacuation,
  gasSuppression,
  reeksHydrants,
  kitchenSuppression,
  sprinklerSystem,
  smokeControl,
  mistSystem,
  settingsImg,
  createRoleImg,
  createUserImg,
  selectAssetsImg,
  appLogo,
  reportedIcon,
  feedbackIcon,
  auditsIcon,
  complianceIcon,
  premisesIcon,
  alertsIcon,
  tasksIcon,
  assetsIcon,
  riskAssessmentIcon,
};

export default images;
